import { Button, HeadTitle } from 'oui';
import useSurvey from '../../../application/bloc/useSurvey';
import SurveyQuestion from './SurveyQuestion';
import * as S from './Survey.styled';
import { useEffect, useRef, useState } from 'react';

export interface ISurveyProps {
  surveyType: string;
  isBottomSheet?: boolean;
  surveySeq?: number;
  targetSeq?: any;
  onSave?: () => void;
  onClickBottomSheetClose?: () => void;
}

const Survey = (props: ISurveyProps) => {
  const {
    survey,
    enableSave,
    bottomSheet,
    onChangeSelectedOptions,
    onChangeText,
    save,
    onClickCloseButton,
  } = useSurvey(props);

  const targetRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (bottomSheet) {
      setTimeout(() => {
        if (targetRef.current) {
          const top = targetRef.current?.offsetTop ?? 0;
          targetRef.current.style.cssText = `overflow-y: scroll; overflow-x: hidden; max-height: calc(90vh - ${top}px);`;
        }
      }, 300);
    }
  }, []);

  return (
    <>
      {survey && (
        <>
          <HeadTitle
            textTitle={survey.title}
            subTitle={survey.subtitle ?? ''}
            key={`${survey.surveySeq}`}
            buttonIconName={bottomSheet ? 'CloseSharp' : undefined}
            onClickButton={onClickCloseButton}
          />
          <div ref={targetRef}>
            {survey.questions &&
              survey.questions.map((question, index) => {
                return (
                  <SurveyQuestion
                    key={`q_${question.questionSeq}`}
                    question={question}
                    index={index}
                    onChangeAnswers={onChangeSelectedOptions}
                    onChangeText={onChangeText}
                  />
                );
              })}
            <S.ButtonWrap>
              <Button
                flexible={true}
                configuration={'contained'}
                state={`${enableSave ? 'enabled' : 'disabled'}`}
                isDisabled={!enableSave}
                children={'의견 남기기'}
                onClick={save}
              />
            </S.ButtonWrap>
          </div>
        </>
      )}
    </>
  );
};

export default Survey;
